import axios, { InternalAxiosRequestConfig } from "axios";
import { notification } from "antd";
import { initializeSessionId, readToken } from "../utils/DataService";
import { endpoints } from "../utils/constants";


 export const apiBaseUrl= endpoints.itemService

export const sessionId = initializeSessionId();

const apiClient = axios.create({
    baseURL: apiBaseUrl,
    timeout: 5000
});

export const getAuthorizationHeader = () => `Bearer ${readToken()}`;


apiClient.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {

        config.headers.set('sessionId', sessionId || '');
        config.headers.set('Content-Type', 'application/json');
        config.headers.set('Authorization', getAuthorizationHeader());

        return config;
    },
    (error: Error) => {
        return Promise.reject(error);
    }
);

apiClient.interceptors.response.use(
    (response: any) => {

        if (response.data.statusCode && response.data.statusCode !== 200 && response.data.message && response.data.message !== "")
        notification.error({
            message: response.data.message,
            placement: "bottom",
        });
        
        return response;
    },

    (error: any) => {
        const status = error?.response?.status;
        const errorMessage = error?.response?.data?.Message || error?.response?.data?.message;

        if (status === 403 && errorMessage?.toLowerCase().includes("token")) {
            notification.error({
              message: "Session expired. Redirecting to login...",
              placement: "bottom",
            });
      
            // Optional: clear localStorage/sessionStorage if needed
            localStorage.clear();
            sessionStorage.clear();
      
            // ⏳ Redirect to login after delay
            setTimeout(() => {
              window.location.href = "/";
            }, 1000);
      
            return new Promise(() => {});
          }

        if (errorMessage) {
            notification.error({
                message: errorMessage,
                placement: "bottom",
            });
        }

        return Promise.reject(error);
    }
);


export default apiClient;
